
  import Loader from "@/components/app/Loader.vue"
  import { computed, defineComponent, onMounted, provide } from "vue"
  import { useStore } from "vuex"
  import { useI18n } from "vue-i18n"
  import "@/components/account/scss/Account.scss"
  import "@/components/folders/scss/Folders.scss"
  import CreateFolder from "@/components/folders/CreateFolder.vue"

  export default defineComponent({
    name: "Folders",
    components: { Loader, CreateFolder },
    setup() {
      const store = useStore()
      const { t } = useI18n()
      provide("Ti18N", t)

      const shortFolders = computed(() => store.getters.shortFolders)
      const isLoader = computed(() => store.getters.isLoaderItem)

      onMounted(() => store.dispatch("getFoldersList"))

      return { isLoader, shortFolders, t }
    },
  })
